// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pav_Zu2GO2A7AuQziEi6 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100vh;
}

.Pav_Zu2GO2A7AuQziEi6 h1 {
    font-size: 150px;
    margin-bottom: 16px;
    margin-top: 0;
    background: -webkit-linear-gradient(${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}, ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-dark"]});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.XjVG6l_JodC8L0_DiFgg {
    font-size: 36px;
    margin-top: 0;
    margin-bottom: 0;
}

.wiO6KP2b3UDAyArt2msi {
    font-size: 18px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
}

.hmjKwde8ePz6pGbeRTyw {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.hmjKwde8ePz6pGbeRTyw button + button {
    margin-left: 16px;
}

@media screen and (max-width: 768px) {
    .Pav_Zu2GO2A7AuQziEi6 {
        padding: 16px;
        box-sizing: border-box;
    }

    .Pav_Zu2GO2A7AuQziEi6 h1 {
        font-size: 100px;
    }

    .XjVG6l_JodC8L0_DiFgg {
        font-size: 24px;
        text-align: center;
    }

    .wiO6KP2b3UDAyArt2msi {
        font-size: 16px;
        text-align: center;
    }

    .hmjKwde8ePz6pGbeRTyw button {
        width: 100%;
        margin: 8px 0;
    }

    .hmjKwde8ePz6pGbeRTyw button + button {
        margin-left: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/Error/Error.module.css"],"names":[],"mappings":"AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;IAEnB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,+HAAoE;IACpE,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mDAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["@value colors: \"components/library/style/colors.css\";\n@value color-purple, color-purple-dark, color-text-subtle from colors;\n\n.error {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    width: 100%;\n    height: 100vh;\n}\n\n.error h1 {\n    font-size: 150px;\n    margin-bottom: 16px;\n    margin-top: 0;\n    background: -webkit-linear-gradient(color-purple, color-purple-dark);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.subtitle {\n    font-size: 36px;\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.description {\n    font-size: 18px;\n    color: color-text-subtle;\n}\n\n.row {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n\n.row button + button {\n    margin-left: 16px;\n}\n\n@media screen and (max-width: 768px) {\n    .error {\n        padding: 16px;\n        box-sizing: border-box;\n    }\n\n    .error h1 {\n        font-size: 100px;\n    }\n\n    .subtitle {\n        font-size: 24px;\n        text-align: center;\n    }\n\n    .description {\n        font-size: 16px;\n        text-align: center;\n    }\n\n    .row button {\n        width: 100%;\n        margin: 8px 0;\n    }\n\n    .row button + button {\n        margin-left: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-dark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-dark"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"error": `Pav_Zu2GO2A7AuQziEi6`,
	"subtitle": `XjVG6l_JodC8L0_DiFgg`,
	"description": `wiO6KP2b3UDAyArt2msi`,
	"row": `hmjKwde8ePz6pGbeRTyw`
};
export default ___CSS_LOADER_EXPORT___;
